const TONE_BG: Record<string, { bg: string; color: string }> = {
  success: { bg: 'success-50', color: 'success-700' },
  warning: { bg: 'warning-50', color: 'warning-700' },
  error: { bg: 'error-50', color: 'error-700' },
  primary: { bg: 'primary-50', color: 'primary-600' },
  neutral: { bg: 'secondary-100', color: 'secondary-600' },
};

export const tone = (t?: string) => TONE_BG[t ?? ''] ?? TONE_BG.neutral;
